import { render, staticRenderFns } from "./pay-jm.vue?vue&type=template&id=8624c8ba&scoped=true"
import script from "./pay-jm.vue?vue&type=script&lang=js"
export * from "./pay-jm.vue?vue&type=script&lang=js"
import style0 from "./pay-jm.vue?vue&type=style&index=0&id=8624c8ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8624c8ba",
  null
  
)

export default component.exports